export default `
  <p>
    <strong>BLOW MARKETPLACE LTDA</strong>, sociedade empresária limitada, inscrita no CNPJ nº
    <strong>37.486.405/0001-91</strong>, com sede na Avenida Perimetral, nº 1395, Setor Coimbra, Goiânia/GO, CEP
    74.530-020, doravante denominada <strong>LICENCIANTE</strong> ou <strong>TRADICIONAL BET</strong>, e, de outro lado, o(a)
    <strong>AFILIADO(A)</strong>, pessoa física ou jurídica devidamente qualificada no formulário de cadastro
    eletrônico, disponível na plataforma digital da Tradicional Bet, doravante denominado <strong>AFILIADO</strong>,
    celebram o presente Contrato de Adesão ao Programa de Afiliados.
  </p>

  <p class="highlight-text">
    Ao marcar o campo "Li e Concordo com os Termos e Condições de Afiliado Tradicional Bet", o
    usuário declara estar ciente e de acordo com todas as disposições deste instrumento, o qual
    possui validade jurídica plena e imediata.
  </p>

  <h3>CLÁUSULA PRIMEIRA – DO OBJETO</h3>
  <p>
    O presente instrumento tem por objeto a concessão, pela LICENCIANTE, de licença de uso não
    exclusiva e intransferível da Plataforma de Afiliados Tradicional Bet, que permite ao AFILIADO
    promover, divulgar e indicar novos usuários para os produtos e serviços de apostas de quota fixa
    oferecidos pela Tradicional Bet, em conformidade com a Lei nº 13.756/2018 e a Lei nº 14.790/2023.
  </p>

  <h3>CLÁUSULA SEGUNDA – DAS DEFINIÇÕES</h3>
  <p>
    <strong>Afiliado:</strong> pessoa física ou jurídica aprovada pela Tradicional Bet para promover sua marca, captar
    novos jogadores e divulgar campanhas de apostas. <strong>Programa de Afiliados Tradicional Bet:</strong>
    conjunto de ações e ferramentas destinadas à promoção digital da marca, mediante remuneração
    variável. <strong>Comissão:</strong> valor devido ao Afiliado, calculado com base na Receita Líquida de Jogo (Net
    Gaming Revenue – NGR).
  </p>

  <h3>CLÁUSULA TERCEIRA – DA ADESÃO AO PROGRAMA</h3>
  <p>
    A adesão se formaliza mediante cadastro completo do Afiliado, aprovação da Tradicional Bet e
    aceite eletrônico dos presentes Termos. A Tradicional Bet poderá aprovar, suspender ou cancelar
    o cadastro do Afiliado, sem necessidade de justificativa. O Afiliado declara ciência de que não
    existe vínculo empregatício, societário ou associativo entre as partes.
  </p>

  <h3>CLÁUSULA QUARTA – DAS OBRIGAÇÕES DO AFILIADO</h3>
  <p>
    O Afiliado se compromete a divulgar as campanhas e produtos da Tradicional Bet de forma ética,
    responsável e transparente, cumprir integralmente as leis e regulamentos aplicáveis, respeitar a
    Política de Jogo Responsável, utilizar exclusivamente os materiais oficiais, manter seus dados
    atualizados e não realizar anúncios enganosos ou promessas de ganhos fáceis.
  </p>

  <h3>CLÁUSULA QUINTA – DAS OBRIGAÇÕES DA LICENCIANTE</h3>
  <p>
    A Tradicional Bet obriga-se a disponibilizar acesso à plataforma, garantir o pagamento das
    comissões devidas, zelar pela integridade e segurança da plataforma e manter o tratamento de
    dados pessoais conforme a LGPD.
  </p>

  <h3>CLÁUSULA SEXTA – DA REMUNERAÇÃO</h3>
  <p>
    O Afiliado será remunerado com base na Net Gaming Revenue (NGR) dos usuários captados,
    conforme regras publicadas no painel. O pagamento será mensal, mediante emissão de nota
    fiscal. Em caso de fraude ou pendência, as comissões poderão ser retidas até regularização.
  </p>

  <h3>CLÁUSULA SÉTIMA – DA PROPRIEDADE INTELECTUAL E USO DA MARCA</h3>
  <p>
    Todas as marcas, logotipos e materiais publicitários da Tradicional Bet são de propriedade
    exclusiva da LICENCIANTE. O uso indevido implicará rescisão imediata e penalidades cabíveis.
  </p>

  <h3>CLÁUSULA OITAVA – DA CONFIDENCIALIDADE E PROTEÇÃO DE DADOS</h3>
  <p>
    O Afiliado compromete-se a manter sigilo absoluto sobre informações comerciais, técnicas e
    estratégicas, respeitar a LGPD e comunicar incidentes de segurança em até 24 horas.
  </p>

  <h3>CLÁUSULA NONA – DO JOGO RESPONSÁVEL E COMPLIANCE</h3>
  <p>
    O Afiliado compromete-se a adotar práticas compatíveis com o jogo responsável, abstendo-se de
    campanhas voltadas a menores de idade ou públicos vulneráveis, observando todas as normas de
    prevenção à lavagem de dinheiro e integridade.
  </p>

  <h3>CLÁUSULA DÉCIMA – DA RESCISÃO</h3>
  <p>
    O contrato poderá ser rescindido por qualquer das partes mediante aviso prévio de 30 dias, ou
    imediatamente em caso de fraude, violação contratual ou uso indevido da marca. A rescisão não
    gera indenização, salvo comissões devidas até a data de encerramento.
  </p>

  <h3>CLÁUSULA DÉCIMA PRIMEIRA – DISPOSIÇÕES FINAIS</h3>
  <p>
    Este contrato é de natureza civil, podendo ser alterado a qualquer tempo pela Tradicional Bet. O
    uso contínuo implica aceitação das atualizações. O foro eleito para eventuais controvérsias é o da
    Comarca de Goiânia/GO.
  </p>

  <div class="company-info">
    <p><strong>BLOW MARKETPLACE LTDA – CNPJ: 37.486.405/0001-91</strong></p>
    <p><strong>Endereço:</strong> Avenida Perimetral, nº 1395, Setor Coimbra, Goiânia/GO</p>
    <p><strong>E-mail para comunicações:</strong> isaac.ribeiro@tradicional.bet.br</p>
  </div>

  <p class="highlight-text mt-4">
    Ao clicar em "Li e Concordo com os Termos e Condições de Afiliado Tradicional Bet", o usuário
    declara ter lido, compreendido e aceitado integralmente todas as disposições deste contrato.
  </p>
`
